<template>
  <Modal v-model:open="modelValue" :z-index="60" :hide-close-icon="true" max-width="560px">
    <template #default="{ close }">
      <div :class="styles.alert">
        <BuildingIcon :class="styles.icon" />
        <div :class="styles.main">
          <typography variant="h4">{{ title }}</typography>
          <typography v-if="body" variant="body-xl" weight="500">
            {{ body }}
          </typography>
          <typography v-if="description" variant="body-3" weight="500">
            {{ description }}
          </typography>
        </div>
        <BaseButton type="primary" size="xxl" @click="close">
          <template #left-icon><ChevronLeftIcon /></template>
          Вернуться назад
        </BaseButton>
      </div>
    </template>
  </Modal>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import ChevronLeftIcon from 'shared/icons/chevron-left.svg';
import { BaseButton, Modal } from 'src/shared/ui';

import BuildingIcon from './assets/building.svg';
import styles from './styles.module.css';

export interface AlertProps {
  type: '400' | '429' | '500';
}
const props = defineProps<AlertProps>();

const errors = {
  400: {
    title: 'Данные введены неверно',
    body: '',
    description: '',
  },
  429: {
    title: 'Слишком много запросов, попробуйте позже',
    body: '',
    description: '',
  },
  500: {
    title: 'Что-то пошло не так',
    body: 'Внутренняя ошибка сервера.',
    description:
      'На сервере произошла непредвиденная ошибка. Пожалуйста, подождите, она вскоре будет исправленна',
  },
};

const title = computed(() => {
  return errors[props.type].title;
});
const body = computed(() => {
  return errors[props.type].body;
});
const description = computed(() => {
  return errors[props.type].description;
});

const modelValue = defineModel<boolean>({ required: true });
</script>
